<template>
  <v-dialog :value="true" max-width="600" @click:outside="cancel">
    <v-card>
      <v-card-title class="text-h5">{{ props.title }}</v-card-title>

      <v-card-text>
        <vs-wrapper space="base">
          <vs-text>{{ props.subtitle }}</vs-text>
          <vs-text-input
            multiline
            label="Comments"
            rows="4"
            requried
            :value="comments"
            @input="comments = $event"
          />
        </vs-wrapper>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <vs-button label="Cancel" remove-invisible-border type="secondary" @click="cancel" />
        <vs-button label="Submit" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { ref } from 'vue'
import * as Sentry from '@sentry/vue'
import { useGetters } from 'vuex-composition-helpers'

const props = withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
  }>(),
  {
    title: 'Feedback',
    subtitle: 'Tell us about your experience using IronSight',
  },
)

const emits = defineEmits<{
  (event: 'close')
}>()

const comments = ref<string>()

const { getContext: currentUserContext } = useGetters('permissions', ['getContext'])

const cancel = () => {
  emits('close')
}

const submit = () => {
  const eventId = Sentry.captureException(
    new Error('User Feedback Submitted: ' + new Date().toISOString()),
  )

  const userFeedback = {
    associatedEventId: eventId,
    name: currentUserContext.value.name,
    email: currentUserContext.value.email,
    message: comments.value!,
  }

  Sentry.captureFeedback(userFeedback)
  emits('close')
}
</script>
